<mat-card class="border-card" *ngIf="pricingScenario as ps">
    <ng-container *ngIf="ps?.pricingScenarioType !== 'Automated'">
        <div class="scenario-header">
            <div class="scenario-info">
                <div>
                    <a class="strongPhrase" (click)="onScenarioClick(ps.id)">{{ps.name}}</a>
                    <lgv-pricing-status-pill [pricingStatus]="ps?.status"></lgv-pricing-status-pill>
                    <span *ngIf="ps?.status?.code == 'Archived'">Archived on {{ps?.updatedTimestamp | date: 'MM/dd/yy'}}</span>
                </div>
                <div>{{ps.notes}}&nbsp;</div>
            </div>
            <div class="ellipsisMenuWrapper">
                <button mat-button [matMenuTriggerFor]="LoanActionMenu">
                    <fa-icon style="font-size:18px;" icon="bars"></fa-icon>
                </button>
                <mat-menu #LoanActionMenu="matMenu">
                    <div class="ellipsisMenuContent">
                        <button mat-menu-item *ngIf="ps?.status?.code === 'LockRequested' && !lgvUserSvc.IsDLR" (click)="cancelLockRequest(ps)">
                            <fa-icon icon="octagon-xmark"></fa-icon> Cancel Lock Request
                        </button>
                        <button mat-menu-item (click)="onScenarioClick(ps.id)"><fa-icon
                                icon="dollar-sign"></fa-icon>&nbsp;&nbsp; {{ps?.status?.code !== 'Archived' ? 'Price / Edit' : 'Open Pricing'}}</button>
                        <button mat-menu-item *ngIf="ps?.status?.code !== 'LockRequested' && ps?.status?.code !== 'Archived'" (click)="onRefreshOpportunity(ps)"><fa-icon
                                icon="refresh"></fa-icon>&nbsp;&nbsp; Refresh Opportunity</button>
                        <div [ngClass]="{'disabled': (lgvUserSvc.IsPreLicensedAgent$ |async)}">
                            <button *ngIf="ps?.status?.code == 'ReadyToLock'" mat-menu-item
                                (click)="onSendLockRequest(ps)" [disabled]="!lgvPricingSvc.isLockRequestAllowed()">
                                <fa-icon icon="lock"></fa-icon>&nbsp;&nbsp; Send Lock Request
                                <fa-icon *ngIf="(lgvUserSvc.IsPreLicensedAgent$ | async)"
                                    [icon]="['far', 'lock-keyhole']"></fa-icon>
                            </button>
                        </div>
                        <div [ngClass]="{'disabled': (lgvUserSvc.IsPreLicensedAgent$ |async)}"
                            *ngIf="ps?.status?.code == 'InitialPricing'">
                            <button mat-menu-item *ngIf="ps?.pricingScenarioType !== 'Automated'"
                                (click)="onDuplicateScenario(ps)"><fa-icon icon="copy">
                                </fa-icon>&nbsp;&nbsp; Duplicate
                                <fa-icon *ngIf="(lgvUserSvc.IsPreLicensedAgent$ | async)"
                                    [icon]="['far', 'lock-keyhole']"></fa-icon>
                            </button>
                        </div>
                        <div [ngClass]="{'disabled': (lgvUserSvc.IsPreLicensedAgent$ |async)}">
                            <button mat-menu-item (click)="onDeleteScenario(ps)">
                                <fa-icon icon="trash"></fa-icon>
                                &nbsp;&nbsp; Remove
                                <fa-icon *ngIf="(lgvUserSvc.IsPreLicensedAgent$ | async)"
                                    [icon]="['far', 'lock-keyhole']"></fa-icon>
                            </button>
                        </div>

                    </div>
                </mat-menu>
            </div>
        </div>
    </ng-container>

    <ng-container *ngIf="ps?.pricingScenarioType === 'Automated'">
        <div class="scenario-header">
            <div class="scenario-info">
                <div><a class="strongPhrase">{{ps.name}}</a> <lgv-pricing-status-pill
                        [pricingStatus]="ps?.status"></lgv-pricing-status-pill></div>
            </div>
            <div class="ellipsisMenuWrapper">
                <button mat-button [matMenuTriggerFor]="LoanActionMenu">
                    <fa-icon style="font-size:18px;" icon="bars"></fa-icon>
                </button>
                <mat-menu #LoanActionMenu="matMenu">
                    <div class="ellipsisMenuContent">
                        <button mat-menu-item (click)="onScenarioClick(ps.id)"><fa-icon
                                icon="dollar-sign"></fa-icon>&nbsp;&nbsp; Price</button>
                        <button mat-menu-item (click)="onRefreshOpportunity(ps)"><fa-icon
                                icon="refresh"></fa-icon>&nbsp;&nbsp; Refresh Opportunity</button>
                    </div>
                </mat-menu>
            </div>
        </div>
    </ng-container>

    <div style="clear:both"></div>

    <div class="Vert-15"></div>
    <ng-container *ngIf="hasValidRequest as request">
        <div class="row">
            <div class="col-12 col-lg-3">
                <b> {{ps?.pricingScenarioType !== 'Automated' ? 'Purchase Type' : 'Refi Type'}}</b>:
                {{request?.loanInformation?.loanPurpose}}
            </div>
            <div class="col-12 col-lg-3">
                <b>Loan Amount</b>: ${{request?.loanInformation?.baseLoanAmount | number : '1.0-0'}}
            </div>
            <div class="col-12 col-lg-3">
                <b>Last Update</b>: {{ps.updatedTimestamp | date: 'MM/dd/yy'}}
            </div>
        </div>
    </ng-container>


    <div class="Vert-15"></div>

    <div>
        <a (click)="ps.isSelected = !ps.isSelected">
            <span *ngIf="!ps.isSelected"><fa-icon icon="plus"></fa-icon> Expand</span>
            <span *ngIf="ps.isSelected"><fa-icon icon="minus"></fa-icon> Hide</span>
            <span class="d-none d-lg-inline"> Details</span>
        </a>
    </div>

    <mat-expansion-panel class="clear-formatting" [expanded]="ps.isSelected">
        <div class="Vert-15"></div>
        <ng-container *ngIf="!(lgvClientSvc.IsOpportunitiesLoading$ | async)">
            <div class="table-responsive">
                <table class="table table-striped" *ngIf="opportunities$ | async as opportunities">
                    <tr>
                        <th>Type</th>
                        <th>Product</th>
                        <th>Est. Fees</th>
                        <th>Payment</th>
                        <th>Rate</th>
                        <th>APR</th>
                        <th>Term</th>
                    </tr>
                    <tr *ngFor="let o of opportunities">
                        <td class="tableRow"><span style="padding: 0px !important; margin-right: 5px;" *ngIf="o?.opportunityInfo?.isLocked && ps?.status?.code == 'LockRequested'"><fa-icon icon="lock"></fa-icon></span>{{o.opportunityType?.name}}</td>
                        <td class="tableRow">{{o.opportunityInfo.productName}}</td>
                        <td class="tableRow">${{o.opportunityInfo.closingCost | number : '1.0-0' | null}}</td>
                        <td class="tableRow">${{o.opportunityInfo.marketPayment | number : '1.0-0' | null}}</td>
                        <td class="tableRow">{{o.opportunityInfo.matchedRate | number : '1.3-3'}}%</td>
                        <td class="tableRow">{{o.opportunityInfo.matchedApr | number : '1.3-3'}}%</td>
                        <td class="tableRow">{{o.opportunityInfo.loanTermMonths}}</td>
                    </tr>
                </table>
            </div>
        </ng-container>

        <ng-container *ngIf="lgvClientSvc.IsOpportunitiesLoading$ | async">
            <lgv-loading-indicator [CSSClass]="'Small'"></lgv-loading-indicator>
        </ng-container>
    </mat-expansion-panel>



</mat-card>